// extracted by mini-css-extract-plugin
export var connectionButton = "_ar-1";
export var rightPanel = "_ar-3";
export var stepDescription = "_ar-2";
export var stepIcon = "_ar-0";